import React from "react";

export const PageHeader: React.FC = () => {
  return (
    <div className="flex flex-wrap items-center justify-between gap-3 mb-6">
      <div>
        <h1 className="text-black-900 text-xl font-bold">API Keys</h1>
        <p className="text-black-800 text-sm mt-1 opacity-70">
          Manage your API key configurations
        </p>
      </div>
    </div>
  );
};

